import React from "react";
import { CircleCheckBigIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  label: string;
  id?: string;
  className?: string;
};
export function CtaButton({
  label,
  id,
  className = ""
}: CtaButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-[17px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_10px_30px_-8px_rgba(22,163,74,0.6)] transition-[background-color,transform] duration-150 ease-out hover:bg-cta-dark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 md:text-xl ${className}`} data-id="element-28" data-mp="hhj4j3uoy417">
      <CircleCheckBigIcon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-29" data-mp="vc25dauzkzhe" />
      <span data-id="element-30" data-mp="19buwh7afdhpw">{label}</span>
    </a>;
}